import { FaGem } from "react-icons/fa";
import Counter from "../components/Counter";
import img from "../assets/img/about-1.webp";
import "../styles/about-page.css";

const AboutPage = () => {
  return (
    <div className="about-bg">
      <div className="about">
        {/* Giới thiệu */}
        <div className="about__intro section">
          <div className="about__intro-content">
            <h1 className="about__title">Giới thiệu</h1>
            <h2 className="about__subtitle">Học viện Design24</h2>
            <p className="about__description">
              Học viện Design24 là một trong những trung tâm đào tạo uy tín và
              chất lượng hàng đầu trong lĩnh vực Thiết kế đồ họa, Dựng phim, Kỹ
              xảo điện ảnh,... đồng thời cũng cung cấp các dịch vụ liên quan
              trong khu vực và khắp cả nước.
            </p>
            <p className="about__description">
              Với kinh nghiệm thực hiện nhiều dự án với các Đài truyền hình &
              các thương hiệu hàng đầu Việt Nam, chúng tôi tự hào có thể định
              hướng đúng đắn, mang lại những kiến thức và tư duy sáng tạo cho
              các bạn.
            </p>
          </div>

          <div className="about__intro-image-wrapper">
            <img
              src={img}
              alt="Học viện Design24"
              className="about__intro-image"
            />
            <div className="about__stats-overlay">
              <div className="about__stats-icon">
                <FaGem
                  size={36}
                  color="#00ffd"
                />
              </div>
              <div className="about__stats-number">
                <Counter
                  end={1120}
                  duration={2000}
                />
                +
              </div>
              <div className="about__stats-label">Học viên</div>
            </div>
          </div>
        </div>

        {/* Triết lý */}
        <div className="about__philosophy section">
          <div className="about__philosophy-left">
            <h2 className="about__philosophy-title">Về chúng tôi</h2>
            <h3 className="about__philosophy-subtitle">
              Triết lí giáo dục và đào tạo
            </h3>
            <p className="about__philosophy-text">
              Với sứ mệnh đào tạo và phát triển nguồn nhân lực có trình độ
              chuyên môn cho sự phát triển kinh tế, Design24 đặt tiêu chí phát
              triển bản thân, nghề nghiệp và sự hài lòng của học viên lên hàng
              đầu.
            </p>
          </div>
          <ul className="about__philosophy-list">
            <li>Lộ trình khóa học rõ ràng</li>
            <li>Học thực hành 100%</li>
            <li>Hỗ trợ học viên tận tình</li>
            <li>Giảng viên chất lượng</li>
            <li>Linh hoạt thời gian</li>
            <li>Chứng chỉ/Chứng nhận khi hoàn thành khóa học</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
